/**
 * Close the OAuth popup window. Only works for windows opened via `window.open`.
 * Retries: some browsers ignore the first `close()` after async work.
 */
export function closeOAuthPopupAfterRedirect(): void {
  window.close()
  window.setTimeout(() => { if (!window.closed) window.close() }, 100)
}
